import React, {Fragment} from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class HelpPassword extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [ 
        {
          title: 'default',
          isDefault : true
        }
      ],
      modifiers : [],
      states : []
    }

  }

  renderList(topic) { 
    return topic.map((item, index) => 
      <li key={index} className={('mdn-HelpPassword-list-item ')+(item.isDone ? 'mdn-HelpPassword-list-item-done' : null)}>
        <span className={`mdn-HelpPassword-icon mdn-Icon-${item.isDone ? 'verificado' : 'fechar'} mdn-Icon--sm"`}/>
        <p className="mdn-Text mdn-Text--caption">
          {item.requirement}
        </p>
      </li>
    )
  }
 
  render() {

    const { data, ...rest }  = this.props
    const dataHelpPassword = data || this.props.dataHelpPassword || {};
    const props = clearProps(this.props)
    
    return <div {...rest} className={resolveProps(this.props, this.config,'HelpPassword')}  >
      <h3 className="mdn-HelpPassword-title">
        {this.props.children}
      </h3>
      <ul className="mdn-HelpPassword-list">
        {this.renderList(dataHelpPassword)}
      </ul> 
    </div>
  }
}

HelpPassword.propTypes = {
  dataHelpPassword : PropTypes.array
}